export enum TitleEnum{
    MR='Mr',
    MS='Ms',
    MRS='Mrs',
    PROF='Prof',
    DOCTOR='Doctor'
}